// One UI for "a list with stock" (Q27): the builder, the list page (S9) and the guide consensus share the same
// mode switcher, status pill wording and price cell, all from /resolve output (FEEDBACK_PLAN §6).
import { html } from './singles-hub--core--html.js?v=c7c57de095';
import { money, plural } from './singles-hub--format.js?v=c7c57de095';

export const MODES = { cheapest: ['Budget', 'Cheapest legal printing we have.'], exact: ['As listed', 'Only the set and number in your list.'], best: ['Premium', 'Full arts and holos first, when we have them.'] };

// The active mode shows the live build (your printing choices, accepted printings and swaps), so it never goes stale
// after "Use it" (Q9). Other modes show the engine's mode summary.
export function modeTrio(cur, modes, res, { act = 'setMode', key = 'modeKey' } = {}) {
  return html`<div class="mcc-trio" role="radiogroup" aria-label="Build mode" ${key ? html`data-keydown="${key}"` : ''}>${['cheapest', 'exact', 'best'].map((m) => { const x = m === cur && res ? { price: res.price, filled: res.filled } : ((modes || {})[m] || {}); return html`<button type="button" role="radio" aria-checked="${cur === m ? 'true' : 'false'}" tabindex="${cur === m ? 0 : -1}" data-click="${act}" data-v="${m}"><span class="mcc-trio__l">${MODES[m][0]}</span><span class="mcc-trio__p" style="display:block">${money(x.price)}</span><span class="mcc-trio__s">${plural(x.filled || 0, 'card')}</span></button>`; })}</div>`;
}

// Status pill for a resolved slot: [class, text]
export function slotPill(sl) {
  const st = sl.status;
  if (st === 'owned') return ['', 'Owned'];
  if (st === 'full') return ['ok', '✓ In stock'];
  if (st === 'partial') return ['warn', `◐ ${sl.filled} of ${sl.need} in stock`];
  if (st === 'confirm') return ['warn', `${sl.filled > 0 ? `◐ ${sl.filled} in stock · ` : ''}${sl.rem} need${sl.rem === 1 ? 's' : ''} your OK`];
  if (st === 'over_limit') return ['warn', '⚠ Over the 4-copy limit'];
  if (st === 'unrecognised') return ['warn', '⚠ Not recognised'];
  return ['bad', 'Sold out'];
}

// Price cell: line price + "£x ea" (or the usual price when nothing is in stock). Mixed printings at different
// prices show the range ("£0.69–£0.99 ea"), never just the first printing's price.
export function eachText(picks) {
  const u = picks.map((p) => p.unit_price).filter((x) => x != null);
  if (!u.length) return '';
  const lo = Math.min(...u), hi = Math.max(...u);
  return (hi - lo > 0.004 ? `${money(lo)}–${money(hi)}` : money(lo)) + ' ea';
}
export function slotPrice(sl) {
  return html`<b>${sl.line_price > 0 ? money(sl.line_price) : '—'}</b><span>${sl.picks && sl.picks.length ? eachText(sl.picks) : sl.status === 'owned' ? '' : 'from ' + money(sl.usual_price) + ' ea when in stock'}</span>`;
}
